// REISOR_ANDROID_1_0_87_VERSION_SINGLE_SOURCE_V1

export const DRIVER_APP_VERSION_NAME = "1.2.8";
export const DRIVER_APP_VERSION_CODE = 2026110308;

export const DRIVER_ANDROID_PACKAGE =
  "online.cargo_platform.driver";

export const DRIVER_PLAY_STORE_URL =
  `https://play.google.com/store/apps/details?id=${DRIVER_ANDROID_PACKAGE}`;
